import { Form } from "react-bootstrap";
import Calory from "../../assets/images/huobi-token-(ht).png";
import danger from "../../assets/images/danger.png";
import infoCircle from "../../assets/images/info-circle.png";
import { Fragment, useEffect, useState } from "react";

import dollar from "../../assets/images/product-details/dollar-square.svg";

import { SaudiRiyal } from "lucide-react";
import Note from "../../../src/components/note/note";
import NutritionInformation from "./nutrition-information";

const ProductDetails = ({
  Product,
  Sizes,
  selectedSize,
  productPrice,
  productOptions,
  handleCheckboxChange,
  notes,
  setNotes,
  handleSizeChange,
  selectedOptions,
  showMissingOptions,
}) => {
  const [showNutrition, setShowNutrition] = useState(false);
  const [physical_activity, setPhysicalActivity] = useState("");
  const [caffeine_percentage, setCaffeinePercentage] = useState("");
  const [sodium_percentage, setSodiumPercentage] = useState("");

  const [combo_variations, setComboVariations] = useState([]);
  useEffect(() => {
    if (Sizes[0]?.variations) {
      const selected = Sizes[0].variations.find(
        (size) => size.id === selectedSize,
      );

      if (selected) {
        setPhysicalActivity(selected.display_physical_activity);
        setCaffeinePercentage(selected.caffeine_percentage);
        setSodiumPercentage(selected.sodium_percentage);
      }
    }

    if (Sizes[0]?.variations) {
      const offerCategories = Sizes[0].variations.find(
        (size) => size.combo_variations && size.combo_variations.length !== 0,
      );

      if (offerCategories) {
        setComboVariations(offerCategories.combo_variations);
      } else {
        setComboVariations([]);
      }
    }
  }, [selectedSize, Sizes]);

  function getSelectionLabels(option) {
    const {
      is_required,
      min_number_of_modifiers_required,
      max_number_of_modifiers_required,
    } = option;

    const requiredText = is_required === 1 ? "مطلوب" : "اختياري";

    const min =
      min_number_of_modifiers_required !== 0
        ? min_number_of_modifiers_required
        : null;
    const max =
      max_number_of_modifiers_required !== 0
        ? max_number_of_modifiers_required
        : null;

    const selectionWord = (count) => (count === 1 ? "اختيار" : "اختيارات");

    let selectionText = "";

    if (min == null && max == null) {
      selectionText = `اختر على الأقل 1 ${selectionWord(1)}`;
    } else if (min != null && max == null) {
      selectionText = `اختر على الأقل ${min} ${selectionWord(min)}`;
    } else if (min == null && max != null) {
      if (max === 1) {
        selectionText = `اختر ${max} ${selectionWord(max)}`;
      } else {
        selectionText = `اختر حتى ${max} ${selectionWord(max)}`;
      }
    } else if (min != null && max != null && min !== max) {
      selectionText = `اختر من ${min} إلى ${max} ${selectionWord(max)}`;
    } else if (min != null && max != null && min === max) {
      selectionText = `${min} ${selectionWord(min)}`;
    }

    return [requiredText, selectionText];
  }

  const isAllSizesOutOfStock = (item) => {
    const detailsArrays = item.map(
      (variation) => variation?.variation_location_details,
    );

    return detailsArrays.every((details) => {
      // لو التفاصيل فاضية أو مش موجودة نعتبره خلصان
      if (!details || details.length === 0) return true;

      const detail = details[0];

      return detail.in_stock === false || detail.qty_available === 0;
    });
  };

  useEffect(() => {
    if (!selectedSize && Sizes?.[0]?.variations?.length > 0) {
      const firstAvailable = Sizes[0].variations.find(
        (size) => !isAllSizesOutOfStock([size]),
      );

      if (firstAvailable) {
        handleSizeChange(
          firstAvailable.id,
          firstAvailable.discount.final_price,
        );
      }
    }
  }, [selectedSize, Sizes]);

  return (
    <div className="meal-product">
      <div className="meal-img">
        <img src={Product.image} alt={Product.name} />
      </div>

      {/* Start Header of Product Details */}
      <div className="meal-content">
        <div className="dish">
          <div>
            <h3>{Product.name}</h3>
            <p>القسم : {Product.category_name}</p>
          </div>
          <div className="price">
            <p>
              {productPrice} <SaudiRiyal size={16} />{" "}
              <span>
                (
                {Sizes[0]?.variations?.map((size, i) => (
                  <Fragment key={i}>
                    {size.id === selectedSize ? `${size.display_name} ` : ""}
                  </Fragment>
                ))}
                )
              </span>
            </p>
          </div>
        </div>

        <hr />

        <div className="meal-container">
          <div className="meal" onClick={() => setShowNutrition(true)}>
            <img src={danger} alt="danger" className="info-img" />
            <div>معلومات التغذية</div>
            <img src={infoCircle} alt="info-circle" className="info-img" />
          </div>

          <div>|</div>
          <div className="meal">
            <img src={Calory} alt={Product.name} className="info-img" />
            <div>
              السعرات الحرارية:{" "}
              {Sizes[0]?.variations?.map((size, i) => (
                <Fragment key={i}>
                  {size.id === selectedSize && size.calories}
                </Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* End Header of Product Details */}

      <div className="main-container-details">
        {/* Size of Product Details */}

        {combo_variations.length !== 0 ? (
          <div className="size">
            <div className="size-details">
              <div className="icon-container">
                <img src={dollar} alt="dollar" />
                <div>
                  <h3>محتويات العرض</h3>
                </div>
              </div>
            </div>

            <div>
              {combo_variations?.map((v, index) => {
                return (
                  <>
                    <div
                      key={v.variation_id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <p style={{ fontSize: "14px", margin: "0" }}>
                          <span> x{v.quantity} </span>
                          <span>
                            {v.product} ({v.variation_name})
                          </span>
                        </p>
                      </div>
                      <img />
                    </div>
                    {combo_variations?.length - 1 !== index && <hr />}
                  </>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="size">
            <div className="size-details">
              <div className="icon-container">
                <img src={dollar} alt="dollar" />
                <div>
                  <h3>{Sizes[0].name}</h3>
                  <p>اختيار 1</p>
                </div>
              </div>
              <div className="required">مطلوب</div>
            </div>

            <div>
              <Form style={{ padding: "0" }}>
                <div key={"reverse-radio"}>
                  {Sizes[0]?.variations?.map((Size, index) => {
                    const isOut = isAllSizesOutOfStock([Size]);
                    return (
                      <>
                        {" "}
                        <div key={index} className="priceOfSize">
                          <Form.Check
                            reverse
                            label={Size.display_name}
                            name="group1"
                            type="radio"
                            id={`reverse-radio-${index}`}
                            checked={selectedSize === Size.id}
                            disabled={isOut}
                            onChange={() =>
                              handleSizeChange(
                                Size.id,
                                Size.discount.final_price,
                              )
                            }
                          />
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: "20px",
                            }}
                          >
                            <p
                              style={{
                                margin: "0",
                                color: isOut ? "#999999" : "black",
                              }}
                            >
                              {Size.discount.final_price !== "0" && (
                                <>
                                  {Size.discount.final_price}
                                  <SaudiRiyal size={14} />
                                </>
                              )}
                            </p>
                          </div>
                        </div>
                        {Sizes[0]?.variations.length - 1 !== index && <hr />}
                      </>
                    );
                  })}
                </div>
              </Form>
            </div>
          </div>
        )}

        {/*------------------------ Options of Product Details ----------------------*/}
        {productOptions?.length > 0 && (
          <div>
            {productOptions.map((productOption, optionIndex) => {
              const [requiredText, selectionText] =
                getSelectionLabels(productOption);

              return (
                <div
                  key={optionIndex}
                  style={{ marginBottom: "20px" }}
                  className="addon"
                >
                  <div className="addon-details">
                    <div className="icon-container">
                      <img src={dollar} alt="dollar" />
                      <div>
                        <h3>{productOption.name}</h3>
                        <p
                          style={{
                            color:
                              showMissingOptions &&
                              productOption.is_required === 1 &&
                              (selectedOptions[optionIndex]?.length || 0) === 0
                                ? "red"
                                : "black",
                          }}
                        >
                          {selectionText}
                        </p>
                      </div>
                    </div>
                    <div className="required">{requiredText}</div>
                  </div>

                  <div>
                    <Form style={{ padding: "0" }}>
                      <div key={"reverse-checkbox"}>
                        {productOption?.variations?.map((variation, index) => {
                          const selectedGroup =
                            selectedOptions[optionIndex] || [];
                          const selectedCount = selectedGroup.length;
                          const isSelected = selectedGroup.includes(
                            variation.id,
                          );
                          const max = Number(
                            productOption.max_number_of_modifiers_required ?? 0,
                          );
                          // console.log(
                          //   "max:",
                          //   productOption.max_number_of_modifiers_required,
                          // );

                          const isDisabled =
                            max > 0 && selectedCount >= max && !isSelected;

                          return (
                            <>
                              {" "}
                              <div
                                key={variation.id}
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  gap: "10px", // optional spacing
                                  fontSize: "14px",
                                }}
                              >
                                <Form.Check
                                  // style={{ color: "#838383" }}
                                  reverse
                                  label={variation.display_name}
                                  name={`group-${optionIndex}`}
                                  type="checkbox"
                                  id={`checkbox-${optionIndex}-${index}`}
                                  checked={isSelected}
                                  disabled={isDisabled}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      variation.id,
                                      variation.discount.final_price,
                                      optionIndex,
                                      productOption.id,
                                    )
                                  }
                                />
                                <p
                                  style={{
                                    fontSize: "14px",
                                    margin: 0,
                                    color: isDisabled ? "#838383" : "black",
                                  }}
                                >
                                  {variation.discount.final_price !== "0" && (
                                    <>
                                      {variation.discount.final_price}
                                      <SaudiRiyal size={14} />
                                    </>
                                  )}
                                </p>
                              </div>
                              {productOption.variations.length - 1 !==
                                index && <hr />}
                            </>
                          );
                        })}
                      </div>
                    </Form>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/*------------------------ End Options of Product Details ----------------------*/}

        {/* Note of Product Details */}
        <Note
          notes={notes}
          setNotes={setNotes}
          text="أضف ملاحظاتك علي الاوردر"
          title="أضف ملاحظاتك"
        />
        {/* End Note of Product Details */}

        {showNutrition && (
          <NutritionInformation
            onClose={() => setShowNutrition(false)}
            allergens={Product?.allergens}
            physical_activity={physical_activity}
            caffeine_percentage={caffeine_percentage}
            sodium_percentage={sodium_percentage}
          />
        )}
      </div>
    </div>
  );
};

export default ProductDetails;
